import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CookieConsentService 
{
	consentGiven = signal<boolean>(true);
	decisionMade = signal<boolean>(false);

	constructor() 
	{
		const stored = localStorage.getItem('cookieConsent');
		this.consentGiven.set(true);
		if (stored === 'accepted') 
		{
			this.decisionMade.set(true);
		}
	}

	isAccepted(): boolean
	{
		return this.consentGiven(); // Return the current value of the signal
	}

	accept() 
	{
		localStorage.setItem('cookieConsent', 'accepted');
		this.consentGiven.set(true);
		this.decisionMade.set(true);
	}

	reject() {
		this.accept();
	}
}
